/* eslint-disable react/no-array-index-key */
import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components'
import { Slider, Modal, ModalHeader, ModalContent } from '@sainsburys-tech/bolt'
import Quote from './Quote.jsx'
import { StyledContainer, StyledWrapper, StyledModalContainer } from './M022.styles'
import { createGolDataAttributes } from '../../../helpers/tracking'

/**
 * M022 is a component that displays reviews by customers or bloggers.
 */
const M022 = ({ onLinkClick, quotes }) => {
  const [show, setModalShow] = useState(false)
  const [quoteContent, setQuoteContent] = useState([])

  const theme = useContext(ThemeContext)
  const channel = theme?.channel
  const isSainsburys = channel === 'sainsburys'

  const quoteModal = (modalSettings) => {
    setModalShow(true)
    setQuoteContent(modalSettings)
  }

  const getGOLDataAttributes = (action = 'Load') =>
    createGolDataAttributes('isolated', 'M022 - NA', undefined, undefined, undefined, action)

  const renderSlider = () => {
    const slideProps = {
      itemsPerSlideXs: 1,
      itemsPerSlideSm: 2,
      itemsPerSlideMd: 2,
      itemsPerSlideLg: 3,
      isInfiniteCycle: true,
      className: 'm022__slider',
      slideClass: 'm022__slide',
      showChevrons: true
    }

    const quoteSlides = quotes.map((quote, index) => (
      // TODO - DS grid migration
      <StyledWrapper className={!isSainsburys ? 'xs-row xs-12 sm-6 lg-4' : ''} key={`quote-${index}`}>
        <StyledContainer numberOfQuotes={quotes.length <= 3}>
          <Quote
            quoteModal={(modalSettings) => quoteModal(modalSettings)}
            quoteIndex={index}
            onLinkClick={onLinkClick}
            brand={channel}
            {...quote}
          />
        </StyledContainer>
      </StyledWrapper>
    ))
    return <Slider {...slideProps} items={quoteSlides} />
  }

  const modalProps = {
    id: 'M022-quote-modal',
    slim: false,
    show,
    onClose: () => setModalShow(false),
    height: 'auto',
    children: (
      <>
        <ModalHeader />
        <ModalContent>
          <Quote data-test='m022-quote-container' onLinkClick={onLinkClick} {...quoteContent} insideModal />
        </ModalContent>
      </>
    )
  }

  return (
    // TODO - DS grid migration
    <StyledModalContainer
      className={!isSainsburys ? 'xs-row xs-12--negative' : ''}
      data-test='m022-slider-container'
      {...getGOLDataAttributes('Load')}
    >
      {renderSlider()}
      <Modal {...modalProps} />
    </StyledModalContainer>
  )
}

M022.propTypes = {
  /** Array of reviews */
  quotes: PropTypes.arrayOf(
    PropTypes.shape({
      blogger: PropTypes.shape({
        /** Image of the blogger */
        avatar: PropTypes.number.isRequired,
        /** Text below the blogger's name */
        linkName: PropTypes.string.isRequired
      }),
      /** Text for the review body copy */
      bodyCopy: PropTypes.string,
      /** Limit of characters for the body copy text, defaults to 500 */
      bodyCopyCharLimit: PropTypes.number,
      /** Link that appears at the end of the body copy */
      ctaCopy: PropTypes.string,
      /** Text for the heading */
      heading: PropTypes.string,
      /** Additional images, max up to 4 */
      images: PropTypes.arrayOf(
        PropTypes.shape({
          /** Image source */
          source: PropTypes.string,
          /** Alt text for the image */
          altText: PropTypes.string
        })
      ),
      /** Ability to change the main image */
      insideModal: PropTypes.bool,
      /** This shows the product image which is either lifestyle of product cutout */
      mainImage: PropTypes.shape({
        /** Main image source */
        source: PropTypes.string,
        /** Main image alt text */
        altText: PropTypes.string,
        /** Main image link URL */
        linkUrl: PropTypes.string,
        /** Link title, can be seen when hovering over the image */
        linkTitle: PropTypes.string,
        /** Option of opening in a new tab, defaults to an empty string  */
        linkTarget: PropTypes.oneOf(['', '_blank', '_self'])
      }),
      /** Customer or blogger name  */
      name: PropTypes.string,
      /** Function to handle the click */
      onLinkClick: PropTypes.func,
      /** Index of the quote */
      quoteIndex: PropTypes.number,
      /** Function that opens a modal in a separate window */
      quoteModal: PropTypes.func,
      /** Star rating out of 5 */
      rating: PropTypes.number,
      /** Text for which badge should render */
      badge: PropTypes.oneOf(['none', 'TrustPilot', 'ArgosTesters'])
    })
  )
}

export default M022
